export default __webpack_public_path__ + "9477e851bef2b453176ee8abe2fc3c3d.pdf";